import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

/** What an import should do with content the page already has. */
export type WikiImportMode = 'replace' | 'append' | 'cancel';

/**
 * Asked before a document is imported into a page that already has content,
 * and before anything is uploaded, so a cancelled import leaves nothing behind.
 */
@Component({
    selector: 'wiki-import-mode-modal',
    template: require('./wiki.import-mode-modal.component.html')
})
export class WikiImportModeModalComponent {
    constructor(public activeModal: NgbActiveModal) {}

    choose(mode: WikiImportMode): void {
        this.activeModal.close(mode);
    }
}
